export default __webpack_public_path__ + "static/media/guiche metralhadora.c6bae15e.png";